<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      // The account name shown in the form
      name: "",

      // The account handle
      handle: "",

      // Whether marketing emails are enabled
      marketingEmailsEnabled: false,
    };
  },

  computed: {
    // Mapped vuex state
    ...mapState(["user"]),
  },

  // When the component is created, fill the form with the user's
  // account name and handle
  created() {
    this.name = this.user.name;
    this.handle = this.user.handle;
    this.marketingEmailsEnabled = this.user.marketing_emails_enabled;
  },

  methods: {
    // When the form is submitted, update the account via the API
    async submit() {
      await this.putAccount({
        name: this.name,
        handle: this.handle,
        marketingEmailsEnabled: this.marketingEmailsEnabled,
      });
    },

    // Mapped vuex actions
    ...mapActions(["putAccount"]),
  },
};
</script>

<template>
  <b-card>
    <b-card-text>
      <b-form @submit.stop.prevent="submit">
        <b-row>
          <b-col>
            <b-form-group id="name-group" label="Name" label-for="name">
              <b-form-input
                id="name"
                v-model="name"
                placeholder="Name"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="handle-group" label="Handle" label-for="handle">
              <b-form-input
                required
                id="handle"
                v-model="handle"
                placeholder="Handle"
                minlength="3"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-checkbox class="mb-3" v-model="marketingEmailsEnabled">
          Opt in to emails about Navier and mine.app
        </b-form-checkbox>

        <b-button type="submit" variant="primary">
          Update Account Settings
        </b-button>
      </b-form>
    </b-card-text>
  </b-card>
</template>
